import React, { useState } from 'react'
import { FaDatabase, FaSync } from 'react-icons/fa'
import { getBackendUrl } from '../../helpers/url'
import { Link, useOutletContext } from 'react-router-dom'
import { fancyTimeFormat } from '../../helpers/fancyTimeFormat'

import { useSocketState } from '../../helpers/useSocket'

const BACKEND_BASE_URL = getBackendUrl()

function StatsDashboard() {
	const [aoe4world] = useSocketState('Aoe4world')

	const { socket } = useOutletContext()

	function getTournamentStats() {
		socket.emit('getTournamentStats')
	}

	return (
		<div>
			<button
				className="h-8 my-auto mr-2"
				onClick={getTournamentStats}
				disabled={aoe4world?.statsLoading}
			>
				Get Stats
			</button>

			<div className="flex flex-row">
				<table className="text-sm border-collapse">
					<thead>
						<tr className="text-left border-b border-gray-300">
							<th className="pr-4 pb-2 w-8">#</th>
							<th className="pr-6 pb-2 w-16">Civilization</th>
							<th className="pr-4 pb-2 text-right">Picks</th>
							<th className="pr-4 pb-2 text-right">1st Pick</th>
							<th className="pr-4 pb-2 text-right">Wins</th>
							<th className="pr-4 pb-2 text-right">Losses</th>
							<th className="pr-4 pb-2 text-right">Bans</th>
							<th className="pr-4 pb-2 text-right">Snipes</th>
							<th className="pb-2 text-right">Winrate</th>
						</tr>
					</thead>
					<tbody>
						{aoe4world?.tournamentStats.civs.map((civ, i) => (
							<tr
								key={civ.civilization}
								className="border-b border-gray-100 last:border-0 hover:bg-gray-50"
							>
								<td className="pr-4 py-1.5 text-gray-400">
									{i + 1}
								</td>
								<td className="pr-6 py-1.5">
									<div className="flex items-center gap-2">
										{civ.flagUrl && (
											<img
												src={civ.flagUrl}
												className="w-5 h-5 object-contain"
											/>
										)}
										<span>{civ.civilization}</span>
									</div>
								</td>
								<td className="pr-4 py-1.5 text-right  font-mono">
									{civ.picked}
								</td>
								<td className="pr-4 py-1.5 text-right font-mono text-blue-600">
									{civ.firstPicked}
								</td>
								<td className="pr-4 py-1.5 text-right font-mono text-green-600">
									{civ.wins}
								</td>
								<td className="pr-4 py-1.5 text-right font-mono text-red-500">
									{civ.losses}
								</td>
								<td className="pr-4 py-1.5 text-right font-mono text-yellow-600">
									{civ.banned}
								</td>
								<td className="pr-4 py-1.5 text-right font-mono text-blue-600">
									{civ.sniped}
								</td>
								<td className="py-1.5 text-right font-mono">
									{civ.winrateString}
								</td>
							</tr>
						))}
					</tbody>
				</table>

				<div className="flex flex-col gap-6 ml-8">
					<div>
						<h2 className="text-sm font-semibold text-gray-500 uppercase tracking-wide">
							Average Duration
						</h2>
						<p className="text-2xl font-mono">
							{fancyTimeFormat(
								aoe4world?.tournamentStats.averageDuration,
							)}
						</p>
					</div>

					{aoe4world?.tournamentStats.mostCommonMatchup && (
						<div>
							<h2 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
								Most Common Matchup
							</h2>
							<div className="flex items-center gap-4">
								<div className="flex flex-col items-center gap-1">
									{aoe4world.tournamentStats.mostCommonMatchup
										.civ1FlagUrl && (
										<img
											src={
												aoe4world.tournamentStats
													.mostCommonMatchup
													.civ1FlagUrl
											}
											className="w-10 h-10 object-contain"
										/>
									)}
									<span className="text-sm font-medium">
										{aoe4world.tournamentStats
											.mostCommonMatchup.civ1Label ??
											aoe4world.tournamentStats
												.mostCommonMatchup.civ1}
									</span>
									<span className="text-xs font-mono text-green-600">
										{
											aoe4world.tournamentStats
												.mostCommonMatchup.civ1Wins
										}
										W
									</span>
								</div>

								<div className="flex flex-col items-center gap-1">
									<span className="text-lg font-bold">
										vs
									</span>
									<span className="text-xs text-gray-400">
										{
											aoe4world.tournamentStats
												.mostCommonMatchup.count
										}{' '}
										games
									</span>
								</div>

								<div className="flex flex-col items-center gap-1">
									{aoe4world.tournamentStats.mostCommonMatchup
										.civ2FlagUrl && (
										<img
											src={
												aoe4world.tournamentStats
													.mostCommonMatchup
													.civ2FlagUrl
											}
											className="w-10 h-10 object-contain"
										/>
									)}
									<span className="text-sm font-medium">
										{aoe4world.tournamentStats
											.mostCommonMatchup.civ2Label ??
											aoe4world.tournamentStats
												.mostCommonMatchup.civ2}
									</span>
									<span className="text-xs font-mono text-green-600">
										{
											aoe4world.tournamentStats
												.mostCommonMatchup.civ2Wins
										}
										W
									</span>
								</div>
							</div>
						</div>
					)}

					{aoe4world?.tournamentStats.liquipediaUpdatedAt && (
						<div>
							<h2 className="text-sm font-semibold text-gray-500 uppercase tracking-wide">
								Liquipedia Updated
							</h2>
							<p className="text-sm font-mono text-gray-600">
								{new Date(
									aoe4world.tournamentStats
										.liquipediaUpdatedAt,
								).toLocaleString()}
							</p>
						</div>
					)}
				</div>
			</div>
		</div>
	)
}

export default StatsDashboard
